import React from 'react'

import { styled } from '~/styled'

export const TABLE_HEADER_THEMES = {
  PRIMARY: 'primary',
  PRIMARY_DARK: 'primaryDark',
  PRIMARY_LIGHT: 'primaryLight',
  LIGHT: 'light',
  WHITE: 'white'
} as const

const StyledTableHeader = styled('thead', {
  base: [],
  variants: {
    theme: {
      [TABLE_HEADER_THEMES.PRIMARY]: ['[&_th]:bg-primary-800'],
      [TABLE_HEADER_THEMES.PRIMARY_DARK]: ['[&_th]:bg-primary-1000'],
      [TABLE_HEADER_THEMES.PRIMARY_LIGHT]: [
        '[&_th]:bg-primary-200',
        '[&_th]:text-grey-1000'
      ],
      [TABLE_HEADER_THEMES.LIGHT]: [
        '[&_th]:bg-grey-100',
        '[&_th]:text-grey-1000'
      ],
      [TABLE_HEADER_THEMES.WHITE]: ['[&_th]:bg-white', '[&_th]:text-grey-1000']
    },
    isSticky: {
      true: ['sticky', 'top-0', 'z-3']
    }
  }
})

type TableHeaderProps = React.ComponentProps<typeof StyledTableHeader>

export const TableHeader = ({
  theme = 'primaryDark',
  isSticky = false,
  ...rest
}: TableHeaderProps) => {
  return <StyledTableHeader theme={theme} isSticky={isSticky} {...rest} />
}

TableHeader.displayName = 'TableHeader'
